import { render, staticRenderFns } from "./ProjectAdd.vue?vue&type=template&id=2f884e5c&scoped=true"
import script from "./ProjectAdd.vue?vue&type=script&lang=js"
export * from "./ProjectAdd.vue?vue&type=script&lang=js"
import style0 from "./ProjectAdd.vue?vue&type=style&index=0&id=2f884e5c&prod&lang=less&scoped=true"
import style1 from "./ProjectAdd.vue?vue&type=style&index=1&id=2f884e5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f884e5c",
  null
  
)

export default component.exports